<template>
    <div v-if="location.name != ''" class="address">
        <!-- <h3>{{ location.name }}</h3> -->
        <div class="title">Address</div>
        <p>
            {{ location.address }}<br />
            {{ location.zipAndCity }}<br />
            <i class="fa fa-clock-o" v-if="location.openingHours != ''"></i> {{ location.openingHours }}
        </p>
    </div>
</template>

<script>
export default {
    name: "LocationDetails",
    props: ["location"],
};
</script>

<style lang="scss" scoped>
.address{
    text-align: center;
    .title{
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        color: rgba(32, 32, 32, 0.5);
    }
    p{
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--agile-black);
    }
}
</style>
